class CashierPerformanceController extends AbstractController
	@register()
	@inject 'translate'

	MAX_TIME_PERIOD_IN_SECONDS: 60 * 60 * 24 * 31 * 3 # 3 months

	initialize: ->
		@reportFilter =
			from:
				moment()
					.subtract(1, 'weeks')
					.set({hour: 0, minute: 0, second: 0})
					.unix()
			to: moment().unix()

		@datePickerConfig = singleDatePicker: true

	onTimePeriodChange: ->
		@resetErrors()

		if @reportFilter.to - @reportFilter.from > @MAX_TIME_PERIOD_IN_SECONDS
			@addErrorMessage(
				@translate('general.time.period'),
				'wbo.report.cashier_performance.time.period.validation.max.length'
			)

		if @reportFilter.from >= @reportFilter.to
			@addErrorMessage(
				@translate('general.time.period'),
				'wbo.report.cashier_performance.time.period.validation.max.start_less_than_end'
			)
